import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { WHATSAPP_URL } from './WhatsAppButton';
export function FloatingWhatsApp() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);
  return <AnimatePresence data-id="element-25">
      {isVisible && <motion.a initial={{
      opacity: 0,
      scale: 0.5,
      y: 50
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.5,
      y: 50
    }} href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 group" data-id="element-26">
          <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 px-4 py-2 bg-darkCard border border-white/10 rounded-lg text-sm font-bold text-white whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-xl" data-id="element-27">
            Unirme al grupo
            <div className="absolute top-1/2 -right-1.5 -translate-y-1/2 w-3 h-3 bg-darkCard border-t border-r border-white/10 rotate-45" data-id="element-28" />
          </div>

          <div className="relative flex items-center justify-center w-16 h-16 bg-whatsapp hover:bg-whatsappHover text-white rounded-full shadow-[0_0_20px_rgba(37,211,102,0.4)] transition-colors duration-300" data-id="element-29">
            <div className="absolute inset-0 rounded-full border-2 border-whatsapp animate-ping opacity-50" data-id="element-30" />
            <MessageCircle className="w-8 h-8 fill-white" data-id="element-31" />
          </div>
        </motion.a>}
    </AnimatePresence>;
}